/**
 * BrandCard Component
 *
 * Card displaying a brand with logo, name, and social links.
 * Background color and content controlled via Prismic.
 *
 * @param {object} props
 * @param {object} props.brand - Brand data from Prismic
 */

import React from "react";
import Icon from "../Icon";
import * as styles from "./BrandCard.module.scss";

const BrandCard = ({ brand }) => {
  const {
    brand_name,
    brand_logo,
    brand_description: _brand_description, // eslint-disable-line no-unused-vars
    brand_background_color,
    brand_link,
    instagram_url,
    twitter_url,
    tiktok_url,
    youtube_url,
    facebook_url,
  } = brand;

  const socialLinks = [
    { platform: "instagram", url: instagram_url },
    { platform: "twitter", url: twitter_url },
    { platform: "tiktok", url: tiktok_url },
    { platform: "youtube", url: youtube_url },
    { platform: "facebook", url: facebook_url },
  ].filter(link => link.url);

  const cardStyle = brand_background_color
    ? { "--card-bg": brand_background_color }
    : {};

  const CardWrapper = brand_link?.url ? "a" : "div";
  const wrapperProps = brand_link?.url
    ? {
        href: brand_link.url,
        target: brand_link.target || "_blank",
        rel: "noopener noreferrer",
      }
    : {};

  return (
    <CardWrapper
      className={`${styles.card} ${socialLinks.length > 0 ? styles.hasSocial : ""}`.trim()}
      style={cardStyle}
      {...wrapperProps}
    >
      <div className={styles.face}>
        <div className={styles.logoWrapper}>
          {brand_logo?.url && (
            <img
              src={brand_logo.url}
              alt={brand_logo.alt || brand_name || "Brand logo"}
              className={styles.logo}
            />
          )}
        </div>
        {socialLinks.length > 0 && (
          <ul className={styles.socialLinks}>
            {socialLinks.map(({ platform, url }) => (
              <li key={platform}>
                <a
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`${brand_name} on ${platform}`}
                  onClick={e => e.stopPropagation()}
                >
                  <Icon name={platform} size="1.6rem" />
                </a>
              </li>
            ))}
          </ul>
        )}
      </div>
    </CardWrapper>
  );
};

export default BrandCard;
